import {
  IConfigMobile,
  IConfigMobileColors,
  IConfigMobileColorsValidation,
  IConfigMobileConfiguration,
  IConfigMobileFirebaseValidation,
  IConfigMobileLayout,
} from '../types';
import { defaultValidation } from 'src/constants/main';

export const defaultConfigMobileColors: IConfigMobileColors = {
  mainColor: '#ffffff',
  // mapControlsColor: '#ffffff',
  tabBarTextColor: '#ffffff',
  categorySelectionColor: '#ffffff',
  tabBarSelectionColor: '#ffffff',
  priceColor: '#ffffff',
  saveButtonBackgroundColor: '#ffffff',
};

export const defaultConfigMobileLayout: IConfigMobileLayout = {
  timePickerPosition: 'menu',
  menuLayout: 'vertical',
  menuListLayout: 'slider',
};

export const defaultConfigMobileConfiguration: IConfigMobileConfiguration = {
  firebase: {
    apiKey: '',
    projectId: '',
    secondApiKey: '',
    secondProjectId: '',
    appStaffApiKey: '',
    appStaffProjectId: '',
  },
  firebaseWeb: {
    apiKey: '',
    authDomain: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
};

export const defaultConfigMobile: IConfigMobile = {
  colors: defaultConfigMobileColors,
  layout: defaultConfigMobileLayout,
  configuration: defaultConfigMobileConfiguration,
};

export const defaultConfigMobileColorsValidation: IConfigMobileColorsValidation = {
  isValid: true,
  mainColor: defaultValidation,
  // mapControlsColor: defaultValidation,
  tabBarTextColor: defaultValidation,
  categorySelectionColor: defaultValidation,
  tabBarSelectionColor: defaultValidation,
  priceColor: defaultValidation,
  saveButtonBackgroundColor: defaultValidation,
};

export const defaultConfigMobileFirebaseValidation: IConfigMobileFirebaseValidation = {
  isValid: true,
  apiKey: defaultValidation,
  projectId: defaultValidation,
  appStaffApiKey: defaultValidation,
  appStaffProjectId: defaultValidation,
};
